import { fetchApi } from '../../../lib/fetchApi';
import { ClaimAlertState } from "../../claims/types";

export const updageAlertClaim = async (claimId: number, body: ClaimAlertState): Promise<void> => {
    await fetchApi.put(`/alert/claim/${claimId}`, body);
};